module.exports = __webpack_public_path__ + "img/Sliders.7174c3af.svg";